module.exports = __webpack_public_path__ + "static/artisto-logo.275bbc0b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/artisto-logo.svg
// module id = 138
// module chunks = 213534597649335 267404087596173